export default "__VITE_ASSET__DqoETxNN__"